import styled from 'styled-components'

export const FooterRoot = styled.footer`
	display: flex;
	grid-area: footer;
	align-items: center;
	padding: 0 10px;
	border-top: 1px solid #dcdada;
`
